import * as React from "react";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import CreditParameter from "./creditparameter";
import "./styles.scss";
import CreditMeter from "creditreport/creditMeter";
import {getAuthExternalStatus} from "../service";
import Layout from "components/gobacklayout";
import {imageBaseUrl} from "config";
import BasicCard from "myshubhlife-component/card";

interface IConnectProps {
    userId: number;
    creditScore: number;
    quantitative: any;
    qualitative: any;
    config: any;
    partnerName: string;
    dispatch?: (action: any) => void;
    loading: boolean;
    isAndroid: boolean;
}

function CreditReportAnalysis(props: IConnectProps) {
    const pathname = props.partnerName && props.partnerName !== "sl" ? `/${props.partnerName}` : "/";
    const authExternal = getAuthExternalStatus();
    const [experianReport, updateExperianReport] = useState<any>(null);
    const [creditScore, updateCreditScore] = useState<number>(props.creditScore);
    const [qualitative, updateQualitative] = useState<any>(props.qualitative);
    const [quantitative, updateQuantitative] = useState<any>(props.quantitative);

    useEffect(() => {
        updateCreditScore(props.creditScore);
        updateQualitative(props.qualitative);
        updateQuantitative(props.quantitative);
    }, [props.creditScore, props.qualitative, props.quantitative]);
    return(
            <Layout
                loading={props.loading}
                pathname={props.isAndroid ? null : pathname}>
                {props.creditScore ?
                    renderCreditScore(qualitative, quantitative, experianReport, Math.floor(creditScore)) :
                    <div className="empty-message-container">
                        <BasicCard>
                            <p>Please generate your credit report before applying for a loan.</p>
                        </BasicCard>
                    </div>
                }
            </Layout>
    );
}
function renderShubhLoanScore(creditScore) {
    return <CreditMeter creditScore={creditScore}/>;
}
function renderCreditParam(key, value) {
    return (<div key={key}>
            <div className="progress-container display-inline">
                <div className="row">
                    <div className="col">
                        <div className="float-left">
                            <span>{key}</span>
                        </div>
                        <div className="float-right">
                            <h6>{value}</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
function renderCreditScore(qualitative, quantitative, experianReport, creditScore) {
        return (
            <div className="credit-report-layout col-md-6 offset-md-3 layout-remove-padding">
                <div className="card text-center card-primary">
                    <div className="card-header list-head list-header-size">MYSHUBHLIFE SCORE</div>
                    <div className="card-body pb-2">
                        {creditScore && renderShubhLoanScore(creditScore)}
                    </div>
                </div>
                {/*Quantitative*/}
                <div className="card report card-primary">
                    <div className="card-header text-center list-header-size">
                        Primary
                    </div>
                    <div className="card-body list-body">
                        {Object.keys(quantitative).map((key, index) => {
                            return <div className="card-items" key={index}>
                                    <CreditParameter
                                        creditParam={key}
                                        creditParamScore={quantitative[key]}/>
                                    </div>;
                        })}
                    </div>
                </div>
                {/*Qualitative*/}
                <div className="card mb-5 report card-secondary">
                    <div className="card-header list-head text-center list-header-size">
                        Secondary
                    </div>
                    <div className="card-body list-body">
                        {Object.keys(qualitative).map((key, index) => {
                            if (key !== "Soft Connections") {
                                return <div className="card-items" key={index}>
                                        <CreditParameter
                                            creditParam={key}
                                            creditParamScore={qualitative[key]}/>
                                        </div>;
                                }
                            })}
                    </div>
                </div>
                { experianReport !== null &&
                <div className="card mb-5 report">
                    <div className="card-header text-center list-head list-header-size">
                        Experian
                    </div>
                    <div className="card-body list-body">
                        {renderCreditParam("Experian Score", experianReport.experian_score)}
                        {renderCreditParam("Number of Accounts", experianReport.accounts_n)}
                        {renderCreditParam("Number of Active Accounts", experianReport.accounts_open_n)}
                        {renderCreditParam("Total Outstanding Balance", experianReport.total_outstanding_balance)}
                        {renderCreditParam("Accounts with Outstanding EMI", experianReport.accounts_outstanding_n)}
                        <div style={{ backgroundColor: "gainsboro" , display: "flex" ,
                            alignItems: "center" , justifyContent: "center"}}>
                            <div>Data provided by</div>
                            <img height={"45px"} src={`${imageBaseUrl}/img/logo/Experian_Logo.png`}></img>
                         </div>
                       </div>
                      <div>
                    </div>
                </div>
                }
            </div>
        );
    }

const mapStateToProps = (state): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    const creditReport = state.userform.creditReport;
    return {
        userId: auth.userId,
        creditScore: creditReport !== null ? creditReport.totalScore : 0 ,
        quantitative: creditReport !== null ? creditReport.Quantitative : {},
        qualitative: creditReport !== null ? creditReport.Qualitative : {},
        config: state.userform.config,
        partnerName: state.userform.param,
        loading: state.userform.loading,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(CreditReportAnalysis);
